import Input from "../../components/Input/Input";
import PictureDrop from "../../components/Input/PictureDrop";

const UserForm = ({formik, isOwnProfile}) => {
    //TODO delete this
    if(formik == null) return ;

    return (
        <form id="userForm" onSubmit={formik.handleSubmit}>
            <Input
                name="name"
                label="Name"
                formik={formik}
            />
            <Input
                name="surname"
                label="Surname"
                required={false}
                formik={formik}
            />
            <Input
                name="email"
                label="Email"
                type="email"
                formik={formik}
            />
            <PictureDrop
                name="image"
                label="Profile Picture"
                formik={formik}
            />

            {formik.values.id && (
                <Input
                    type="checkbox"
                    label="Change Password"
                    name="changePassword"
                    formik={formik}
                />
            )}

            {(!formik.values.id || formik.values.changePassword) && (
                <>
                    <Input
                        name="password"
                        type="password"
                        label="Password"
                        formik={formik}
                    />

                    <Input
                        name="confirmPassword"
                        type="password"
                        label="Confirm Password"
                        formik={formik}
                    />
                </>
            )}

            {!isOwnProfile && (
                <Input
                    type="checkbox"
                    name="isAdmin"
                    label="Admin"
                    handleChange={(e) => {
                        formik.setFieldValue('role', e.target.checked ? "admin" : "user")
                    }}
                    checked={formik.values.role === 'admin'}
                />
            )}
        </form>
    )
}

export default UserForm;